/**
 * Uppercases the first non-whitespace character; leaves the rest of the string unchanged.
 */
export function capitalizeLeadingCharacter(text: string): string {
  const match = text.match(/^(\s*)(\S)(.*)$/s);
  if (!match) return text;
  return `${match[1]}${match[2].toUpperCase()}${match[3]}`;
}

/** Free-text fields (company description, questionnaire paragraphs, etc.) for read-only UI. */
export function formatDisplayTextWithLeadingCapital(value: unknown, fallback = "N/A"): string {
  if (value == null || value === "") return fallback;
  return capitalizeLeadingCharacter(String(value));
}

/** Ensures company description fields start with a capital letter before save. */
export function normalizeCompanyDescriptionFields(companyData: Record<string, unknown>): void {
  for (const key of ["description", "subDescription"] as const) {
    if (!(key in companyData)) continue;
    const value = companyData[key];
    if (value == null) continue;
    if (typeof value !== "string") continue;
    const trimmed = value.trim();
    companyData[key] = trimmed ? capitalizeLeadingCharacter(trimmed) : null;
  }
}
